import React, { useContext, useCallback, useMemo, useState } from 'react';
import { Chevron } from '@jutro/components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext, FormattedMessage } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CoveragesComponent from '../../../../Components/CoveragesComponent/CoveragesComponent';
import DiscountComponent from '../../../../Components/DiscountSurchargesDisplayComponent/DiscountSurchargesDisplayComponent';
import metadata from './PolicyDwellingInfo.metadata.json5';
import styles from '../../Summary.module.scss';
import messages from './PolicyDwellingInfo.messages';
import WCMotorDetailsTable from './../WCMotorDetailsTable/WCMotorDetailsTable';
import ScheduleItemsComponent from './../../../../Components/ScheduleItemsComponent/ScheduleItemsComponent'
//Pass the location on the 2nd parameter
const getHeaderSection = (title, title1, title2) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            <div className={styles.row} >
                {title1 && <div > 
                    <h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
                </div>}
                {title2 && <div><h3 className={`${styles.title1} ${styles.gwOverrideDefaultMargin}`}>{title2}</h3></div>}
                
            </div>
        </React.Fragment>
    );
};

function PolicyDwellingInfo(props) {
    const translator = useContext(TranslatorContext);
    const [openItems, setOpenItems] = useState([]);

    const currencyFormatter = Intl.NumberFormat("en-CA", {style: "currency", currency: "CAD"});

    const translateYesNo = (keyObject) => {
        const object = _.cloneDeep(keyObject);
        const appendingYear = (obj, key) => {
            let result = '';
            const mappingYear = {
                heatingUpgraded: 'heatingUpgradeYear',
                plumbingUpgraded: 'plumbingUpgradeYear',
                wiringUpgraded: 'wiringUpgradeYear',
                roofUpgraded: 'roofUpgradeYear'
            };
            const getDisplayYearKey = mappingYear[key];
            if (getDisplayYearKey && obj[key]) {
                result = `(${obj[getDisplayYearKey]})`;
            }
            return result;
        };
        if (!_.isEmpty(object)) {
            _.map(object, (value, key) => {
                if (typeof value === 'boolean') {
                    object[key] = `${translator(
                        value ? messages.infoYes : messages.infoNo
                    )} ${appendingYear(object, key)}`;
                }
            });
        }
        return object;
    };

    const updateCoverages = (dwelling) => {
        const coverages = dwelling.coverageDTOs;
        //Sort the Coverages based on the categoryCodeIdentifier
        let sortedcoverages = _.sortBy(coverages, (cov) => cov.categoryCodeIdentifier);

        const allCoverages = {
            // sectionICoverages: [],
            // sectionIICoverages: [],
            // additionalLiabilityCoverages: [],
            // additionalPropertyCoverages: [],
            dwellingPropertyCoverages: [],
            scheduledItems: []
        };
        sortedcoverages.forEach((coverage) => {
            const cov = coverage;
            if (cov) {
                switch (cov.categoryCodeIdentifier) {
                    case 'HOPSectionICovCat':
                        allCoverages.dwellingPropertyCoverages.push(cov);
                        break;
                    case 'HODW_SectionI_HOE':
                    // allCoverages.sectionICoverages.push(cov);
                    // break;
                    case 'HOPSectionIICovCat':
                    case 'HODW_SectionII_HOE':
                    //   allCoverages.sectionIICoverages.push(cov);
                    //   break;
                    case 'HOPAdditionalCovCat':
                    case 'HOLI_Additional_HOE':
                    //   allCoverages.additionalLiabilityCoverages.push(cov);
                    //   break;
                    case 'HOPPCAdditionalCovCat':
                    case 'HODW_Additional_HOE':
                    //    allCoverages.additionalPropertyCoverages.push(cov);
                    //    break;
                    case 'HOPScheduledItemCovCat':
                        allCoverages.scheduledItems.push(cov);
                        break;
                    case 'HODW_SchedulesCov_HOE':
                        if (cov.specialLimits) {
                            cov.specialLimits.forEach((coverageItem) => {
                                allCoverages.scheduledItems.push(coverageItem);
                            });
                        } else if (cov.scheduledProperty) {
                            cov.scheduledProperty.forEach((coverageItem) => {
                                allCoverages.scheduledItems.push(coverageItem);
                            });
                        }
                        break;
                    default:
                        //Add coverages on the dwellingPropertyCoverages except for scheduleItemCov
                        allCoverages.dwellingPropertyCoverages.push(cov);
                        break;
                }
            }
        });
        //Append the ScheduleItem Coverage
        if (!_.isEmpty(allCoverages.scheduledItems)) {
            allCoverages.dwellingPropertyCoverages = allCoverages.dwellingPropertyCoverages.concat(allCoverages.scheduledItems);
        }

        return allCoverages;
    };

    const getFormattedInfo = (message, key, value) => {
        return (
            <FormattedMessage
                {...message}
                values={{
                    [key]: value
                }}
            />
        );
    };


    const getHomeOwnersData = () => {
        const homeOwnersData = _.cloneDeep(props.value);
        if (_.isEmpty(homeOwnersData.dwellingDTO)) {
            return null;
        }
        homeOwnersData.dwellingDTO.forEach((dwelling) => {

            if (!_.isEmpty(dwelling["homeDetails"])) {
                dwelling.homeDetails = translateYesNo(
                    dwelling.homeDetails
                );
                _.set(
                    homeOwnersData,
                    'dwelling.homeDetails.distanceToFireHydrant',
                    getFormattedInfo(
                        messages.FeetToFireHydrant,
                        'distance',
                        dwelling.homeDetails.distanceToFireHydrant
                    )
                );
                _.set(
                    homeOwnersData,
                    'dwelling.homeDetails.distanceToFireStation',
                    getFormattedInfo(
                        messages.MilesToFireStation,
                        'miles',
                        dwelling.homeDetails.distanceToFireStation
                    )
                );
            }
            if (!_.isEmpty(dwelling.constructionDetails)) {
                dwelling.constructionDetails = translateYesNo(
                    dwelling.constructionDetails
                );
            }
            if (!_.isEmpty(dwelling.miscDetails)) {
                dwelling.miscDetails = translateYesNo(
                    dwelling.miscDetails
                );
            }
            /* if (_.isEmpty(dwelling.mortgageeDetailsDTO)) {
                homeOwnersData.mortgageeDetailsDTO = [];
            } */
            dwelling.allCoverages = updateCoverages(dwelling);
        });

        const houseOwners = _.clone(homeOwnersData);
        let liabilityandExtCoverages = [];
        if (houseOwners.coverageDTOs) {
            liabilityandExtCoverages = houseOwners.coverageDTOs;
        }
        if (houseOwners.liabilityExtensions) {
            liabilityandExtCoverages = liabilityandExtCoverages.concat(houseOwners.liabilityExtensions)
        }

        homeOwnersData.liabilityandExtensionCoverages = liabilityandExtCoverages
        return homeOwnersData;

    };
    const homeOwnersData = getHomeOwnersData();

    if (_.isEmpty(homeOwnersData)) {
        return null;
    }

    const policyLiabilityCoverables = useMemo(() => {
        return homeOwnersData.coverageDTOs;
    }, [homeOwnersData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'dwellingDTO') {
                return homeOwnersData.dwellingDTO;
            }
            else if (path === 'coverageDTOs') {
                return policyLiabilityCoverables;
            }
            return _.get(homeOwnersData, path);
        },
        [homeOwnersData, policyLiabilityCoverables]
    );

    //Show/Hide coverage details 
    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(openItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenItems(openedItem);
            } else {
                setOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [openItems]
    );

    const getDiscountsAndSurcharges = (discounts, surcharges) => {
        let discountSurcharges = [];
        discountSurcharges = discounts && !_.isEmpty(discounts) ? discounts : [];
        discountSurcharges = surcharges && !_.isEmpty(surcharges) ? discountSurcharges.concat(surcharges) : discountSurcharges;
        return _.sortBy(discountSurcharges, 'category');
    };

    const generateAccordionHeaderOverrides = useCallback(() => {
        const overrides = homeOwnersData.dwellingDTO.map((dwelling, index) => {
            const productCode = props.productCode;
            if(productCode === 'Commercial Property') {
                dwelling['allCoverages']= {'dwellingPropertyCoverages': dwelling.coverages};
            }
            let count = index + 1;
            let packageName = translator({
                id: `typekey.HOPCoverageForm.${dwelling.coverageForm}`,
                defaultMessage: "Coverage Form"
            }) + " " + translator({
                id: `typekey.CoveragePartType.${dwelling.coveragePart}`,
                defaultMessage: "Package Type"
            })
          
            let header = "";
            let showCoverages = productCode === 'Commercial Property' ? translator(messages.ShowBuildingCoverages) : translator(messages.ShowCoverages);
            let hideCoverages = productCode === 'Commercial Property' ? translator(messages.HideBuildingCoverages) : translator(messages.HideCoverages);
            if(productCode === 'Commercial Property'){
                const title = `Building # ${dwelling.buildingNumber}: ${dwelling.name}`;
                const title1 = `Item type: ${dwelling.buildingType || dwelling.itemType_EY || '-'}`;
                const title2 = `Value: ${dwelling.buildingValue || dwelling.tivValue_EY || '-'}`;
                header = getHeaderSection(title, title1, title2);
            }
            else {
                const headName = `Location # ${dwelling.displayName || dwelling.address.displayName}`
                const title1 = `Package: ${packageName}`;
                const title2 = `Premium: ${ currencyFormatter.format(dwelling.premium.amount)}`;
                header = getHeaderSection(headName, title1, title2)
            }
            const scheduledItemsVisibility = dwelling.scheduledItems && dwelling.scheduledItems.filter((item) => {
                return item.scheduleItems.length > 0
            }).length > 0;
            const visibleCommonDetailsContainers = (!dwelling.isMarine_EY && !dwelling.isTrailerPackage_EY && !dwelling.isFloatersPackage_EY);
            return {
                [`dwellingPackageDetailsContainer${index}`]: {
                    header: header
                },

                [`contentDetailToggle${index}`]: {
                    icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(openItems, index)
                        ? hideCoverages
                        : showCoverages
                },
                [`CoverageContainer${index}`]: {
                    visible: _.includes(openItems, index),
                    show: openItems
                },
                [`scheduledItemsContainer${index}`]:{
                    visible: !!scheduledItemsVisibility
                },
                [`showContentToggleLink${index}`]: {
                    onClick: () => toggleShowHide(index)
                },
                [`policyDiscounts${index}`]: {
                    data: getDiscountsAndSurcharges(dwelling.discounts, dwelling.surcharges),
                    value: getDiscountsAndSurcharges(dwelling.discounts, dwelling.surcharges),
                    visible: !_.isEmpty(getDiscountsAndSurcharges(dwelling.discounts, dwelling.surcharges))
                }, 
                [`constructionDetailsContainer${index}`]: {
                    visible: visibleCommonDetailsContainers,
                },
                [`protectionDetailsContainer${index}`]: {
                    visible: visibleCommonDetailsContainers,
                },
                [`generalDetailsContainer${index}`]: {
                    visible: visibleCommonDetailsContainers,
                },
                [`waterCraftDetailsContainer${index}`]: {
                    visible: !!dwelling.isMarine_EY,
                },
                [`vacationTrailerDetailsContainer${index}`]: {
                    visible: !!dwelling.isTrailerPackage_EY,
                },
                [`waterCraftMotorDetailsContainer${index}`]: {
                    visible: !!dwelling.isMarine_EY,
                },
                [`WaterCraftMotorDetails${index}`]: {
                    data: dwelling.isMarine_EY ?  dwelling.marine_EY.marineMotorDetails : []
                },
                [`mmDboatVlueHeader${index}`]: {
                    content : dwelling.isMarine_EY ? `Boat Value:    ${dwelling.marine_EY.mmdboatValue}` : ' ',
                    visible: dwelling.isMarine_EY,
                },
            };
        });
        return Object.assign({}, ...overrides);
    }, [homeOwnersData, openItems, toggleShowHide, translator]);

    const generateConstructionDetailsOverride = useCallback( () => {
        const overrides = homeOwnersData.dwellingDTO.map( (dwelling, index) => {
            return  {
                [`roofUpgradedColumn${index}`]: { 
                    visible : !dwelling.constructionDetails.roofUpgraded === 'No'
                },  
                [`plumbingUpgradedColumn${index}`]: { 
                    visible : !dwelling.constructionDetails.plumbingUpgraded === 'No'
                }, 
                [`heatingUpgradedColumn${index}`]: { 
                    visible : !dwelling.constructionDetails.heatingUpgraded === 'No'
                },
                [`wiringUpgradedColumn${index}`]: {
                    visible : !dwelling.constructionDetails.wiringUpgraded === 'No'
                },
                [`constructionType${index}`]: {
                    label: props.productCode === 'Commercial Property' ? translator(messages.propertyOrOccupancy) : translator(messages.occupancyType)
                },
                ...generateCPOverride(index)
            }


        });
        return Object.assign({}, ...overrides);
    },[homeOwnersData]);

    const generateProtectionDetailsOverride = useCallback( () => {
        const overrides = homeOwnersData.dwellingDTO.map( (dwelling, index) => {
            const fireProtectionGrade = dwelling.miscDetails.fireProtectionGrade;
            const ftfdVisible = ['1'];
            const ssVisible = ['1','2'];

            return  {
                [`fullTimeFireDepartmentColumn${index}`]: { 
                    visible : ftfdVisible.includes(fireProtectionGrade)
                },  
                [`superiorShuttleColumn${index}`]: { 
                    visible : ssVisible.includes(fireProtectionGrade)
                }, 
               
            }


        });
        return Object.assign({}, ...overrides);
    },[homeOwnersData]);

    const generateCPOverride = useCallback( (buildingIndex) => {
        const cpNonBuildingDetails = ["buildingAreaColumn", "electricalSystemColumn", "basementFinishedColumn", "roomersOrBordersColumn", "swimmingPoolColumn", "hotTubColumn"]
        const productCode = props.productCode;
        if(productCode === 'Commercial Property'){
            const overrides = cpNonBuildingDetails.map( (column) => {
                return  {
                    [`${column}${buildingIndex}`]: { 
                        visible : false
                    }
                }
            });
            return Object.assign({}, ...overrides);
        }
        return {}
    },[]);

    const overrides = {
        homePackDetailsCard: {
            header: getHeaderSection(translator(messages.HomeDetails))
        },
        homeDetailsCard: {
            header: getHeaderSection(translator(messages.HomeDetails))
        },
        constructionDetailsCard: {
            header: getHeaderSection(translator(messages.ConstructionDetails))
        },
        protectionDetailsCard: {
            header: getHeaderSection(translator(messages.ProtectionDetails))
        },
        liabilityDetailsCard: {
            header: getHeaderSection(translator(messages.LiabilityandExtensions))
        },
        ...generateAccordionHeaderOverrides(),
        ...generateConstructionDetailsOverride(),
        ...generateProtectionDetailsOverride()        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveComponentMap: {
            coveragescomponent: CoveragesComponent,
            discountscomponent: DiscountComponent,
            wcMotorDetailsTable: WCMotorDetailsTable,
            scheduleItemsComponent: ScheduleItemsComponent 
        }
    };
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={homeOwnersData}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}
PolicyDwellingInfo.propTypes = {
    value: PropTypes.shape({}).isRequired
};
export default PolicyDwellingInfo;
